
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(14|31|71|84)|2(27|29|44)|193|313|58|694|792|849|912)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
